import { ERoomIcon } from "../../AppDataType"
import { BedIcon, CityIcon, KitchenIcon, LakeIcon, MountainIcon, RoomQuantityIcon, SafeBoxIcon, ShowerIcon, SizeIcon, WashingMachineIcon, WiFiIcon, WindowShutterIcon } from "../Icons/Icons"

interface Props {
    icon: ERoomIcon;
    className?: string;
}

const RoomIcon: React.FC<Props> = ({ icon, className }) => {
    switch (icon) {
        case ERoomIcon.BED:
            return <BedIcon aria-label="bed-icon" className={className}/>

        case ERoomIcon.SIZE:
            return <SizeIcon aria-label="size-icon" className={className}/>

        case ERoomIcon.WIFI:
            return <WiFiIcon aria-label="wifi-icon" className={className}/>

        case ERoomIcon.SAFEBOX:
            return <SafeBoxIcon aria-label="safebox-icon" className={className}/>

        case ERoomIcon.LAKE:
            return <LakeIcon aria-label="lake-icon" className={className}/>

        case ERoomIcon.MOUNTAIN:
            return <MountainIcon aria-label="mountain-icon" className={className}/>

        case ERoomIcon.CITY:
            return <CityIcon aria-label="city-icon" className={className}/>

        case ERoomIcon.SHOWER:
            return <ShowerIcon aria-label="shower-icon" className={className}/>

        case ERoomIcon.KITCHEN:
            return <KitchenIcon aria-label="kitchen-icon" className={className}/>

        case ERoomIcon.WASHING:
            return <WashingMachineIcon aria-label="washing-machine-icon" className={className}/>

        case ERoomIcon.SHUTTER:
            return <WindowShutterIcon aria-label="window-shutter-icon" className={className}/>

        case ERoomIcon.ROOM:
            return <RoomQuantityIcon aria-label="room-quantity-icon" className={className}/>

        default:
            return null
    }
}

export default RoomIcon
